/**
 * @internal
 */
export type ListIndex = {
  readonly brand: "list_index";
  readonly value: number;
};

/**
 * @internal
 */
export function listIndex(value: number): ListIndex {
  return { brand: "list_index", value };
}
